import RewardItem from './RewardItem';

export default RewardItem;
